// The screens this app has, generated from .appfactory/product-plan.json.
//
// Imported by the navigation shell rather than replacing it: the shell owns
// router.js — bottom-tabs, stack and sidebar produce different routers, and it
// rewrites that file on every `spec apply`. Two owners for one file is a silent
// fight, so the product contributes ROUTES and the shell decides what to do
// with them.
//
// `primary` marks a screen that earns a place in the navigation itself.

import ShelfPage from './pages/ShelfPage.vue';
import KeepingPage from './pages/KeepingPage.vue';
import CookBookPage from './pages/CookBookPage.vue';
import RecipeSheetPage from './pages/RecipeSheetPage.vue';
import BookletPage from './pages/BookletPage.vue';

export const PRODUCT_ROUTES = [
  {
    id: 'shelf',
    path: '/',
    label: 'The shelf',
    component: ShelfPage,
    primary: true,
    destination: true,
  },
  // `capture` is gone. Recording happens on the recipe sheet, in editing mode;
  // an old deep link to /recipe/:id/capture now falls through to the sheet.
  {
    id: 'capture',
    path: '/recipe/:recipeId/capture',
    label: 'Capture',
    component: RecipeSheetPage,
    primary: false,
    destination: false,
  },
  {
    id: 'keeping',
    path: '/keeping',
    label: 'Keeping',
    component: KeepingPage,
    primary: false,
    destination: false,
  },
  {
    id: 'cook-book',
    path: '/cook/:cookId',
    label: 'A cook\'s book',
    component: CookBookPage,
    primary: false,
    destination: false,
  },
  {
    id: 'recipe-sheet',
    path: '/recipe/:recipeId',
    label: 'Recipe sheet',
    component: RecipeSheetPage,
    primary: false,
    destination: false,
  },
  {
    id: 'booklet',
    path: '/cook/:cookId/booklet',
    label: 'Booklet',
    component: BookletPage,
    primary: false,
    destination: false,
  },
];

export const PRIMARY_ROUTES = PRODUCT_ROUTES.filter((r) => r.primary);

// What the navigation offers. NOT the same question as `primary`.
//
// The tab bar was built from PRIMARY_ROUTES, and `primary` means "the screen
// the app opens on" — exactly one screen per plan. So a four-screen app got a
// one-tab tab bar and three screens nothing could reach. `roles` grades
// importance for QA; it was never a claim about navigation.
//
// A destination is a top-level screen someone navigates TO: primary or
// critical, never a detail screen (reached from its list) and never settings
// (which gets its own toolbar button, because a settings tab crowds out a real
// one). Capped at five — past that a bottom bar stops being usable and the
// platform guidelines say so.
export const DESTINATION_ROUTES = PRODUCT_ROUTES.filter((r) => r.destination).slice(0, 5);
export const HOME_ROUTE = (PRIMARY_ROUTES[0] ?? PRODUCT_ROUTES[0])?.path ?? '/';
